import request from "@/utils/request";

export default function getAgentAllDevidend() {
    return request({
        url: `/user/dividend/getAgentAllDevidend`,

    })
}
